import { render, staticRenderFns } from "./About.vue?vue&type=template&id=32afa36a&"
import script from "./About.js?vue&type=script&lang=js&"
export * from "./About.js?vue&type=script&lang=js&"
import style0 from "./About.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports